import { createFileRoute } from '@tanstack/react-router'

import { AchReasonCodesScreen } from './-components/ach-reason-codes-screen.tsx'

export const Route = createFileRoute('/ach/reason-codes')({
  component: AchReasonCodesScreen
})
